import { ForwardRefExoticComponent, FunctionComponent, RefAttributes } from 'react'
import { Menu, MenuProps } from './Menu'
import { MenuItem, MenuItemProps } from './MenuItem'
import { Select, SelectProps } from './Dropdown'

export type DropdownComponent = ForwardRefExoticComponent<SelectProps & RefAttributes<HTMLSelectElement>> & {
  Menu: FunctionComponent<MenuProps>
  MenuItem: FunctionComponent<MenuItemProps>
}

export const Dropdown = Select as DropdownComponent
Dropdown.Menu = Menu
Dropdown.MenuItem = MenuItem

export type { SelectProps }
export * from './constants'
